import autobind from 'class-autobind';

import EventTarget from '@/util/EventTarget.js'
import { findUpTagByClass } from '@/util/findUpTag.js'
import { getIntersects } from '@/util/bounds.js';
import { defaultZoomTo } from '@/reducer/tool';

export default class ZoomHandler {
   constructor(host) {
        autobind(this);

        this.host = host;
   }

//    toggleSelection(id) {
//         const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;
//         if (alreadySelected) {
//             this.host.props.removeSelection([id]);
//         } else {
//             this.host.props.addSelection([id]);
//         }
//     }
   
   tap(event) {
       console.log('TAP?!')
        let gestureTarget = event.detail.gestureStartTarget;

        // const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        // const isTextfield = textfieldElement !== null;
        // if (isTextfield) {
        //     gestureTarget = textfieldElement;
        // }
        // console.log('isTextfield', isTextfield, textfieldElement);

        // console.log('gesture targ', gestureTarget);
        const isDraggable = gestureTarget && gestureTarget.classList && gestureTarget.classList.contains('draggable');

        //const isTriggersDeselect = (gestureTarget && gestureTarget.className && gestureTarget.className.split) ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false; //fillContainer
        


        if (isDraggable ) {

        }  

        const x = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
        const y = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;



        this.host.directed.offsetX = 0;
        this.host.directed.offsetY = 0;
        
        this.host.tweenZoomToZ(1,
            -x, 
            -y,
            20
        );

        this.host.setState({
            isShowingAll: false
        });

        this.host.props.setCurrentTool('SELECT')//this.state.previousTool)


    }

    startdrag(event){
        console.log('EVENT:', 'start drag', event);
        this.host.gestureStartScale = this.host.current.scale;

        if (!event.detail) {
            // Safari zoom gesture
            console.log('safari zoom gesture');
            return;
        }

        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);
        

        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;
            if (isDraggable && !alreadySelected) {
                //this.state.multiselect ||
                if (this.host.props.multiselect) {
                    // console.log("TOGGLE SEL! B")
                    this.toggleSelection(gestureTarget.id);
                } else {
                    // console.log("SET SEL GESTURE! B", this)
                    this.host.props.setSelection([gestureTarget.id]);
                }
                // this.props.editSelected();
                // self.props.setSelection(e.target.id);
            } else {
                console.log('start drag?')
            }

            this.host.handleGestureChanged(event);
        }
        

    }


    change(event) {
        const dx = event.detail.delta.pos.x / this.host.current.scale;
        const dy = event.detail.delta.pos.y / this.host.current.scale;


        let gestureTarget = event.detail.gestureStartTarget;

        if (gestureTarget) {
            // const isTriggersDeselect = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
            const id = gestureTarget.id;
            const alreadySelected = this.host.props.content.selection.indexOf(id) !== -1;

                // console.log("[[[  marquee?  ]]]", event.detail.start.pos.x, event.detail.delta.pos.x, event.detail.current.pos.x, this.host.props.scale, this.host.props.panX, this.host.props.width, 'x', this.host.props.height)
                this.host.didDrag =  false; // ????

                const isBg = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
                //gestureTarget.id == 'background-grid' : false;
        
                if (isBg) {


                    const startX = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
                    const startY = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
            
                    const endX = (event.detail.current.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
                    const endY = (event.detail.current.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
            
                    const bounds = {
                        minX: Math.min(startX, endX),
                        minY: Math.min(startY, endY),
                        maxX: Math.max(startX, endX),
                        maxY: Math.max(startY, endY)
                    };
        
                    // console.log('set marquee', bounds);

                    this.host.props.setZoomTo(bounds);

                    const pendingMultiselect = getIntersects(this.host.props.content.media, bounds);
                    // console.log('pendingMultiselect', pendingMultiselect,this.host.props.content.media);
                    this.host.props.setHover(pendingMultiselect);
                


            }
        }

    }


    enddrag(event) { 
        console.log('enddrag', event);
        this.host.props.setZoomTo();//

        let gestureTarget = event.detail.gestureStartTarget;

        const isBg = gestureTarget ? (gestureTarget.className.split(' ').indexOf('grid') !== -1) : false;
        //gestureTarget.id == 'background-grid' : false;

        if (isBg) {


            const startX = (event.detail.start.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
            const startY = (event.detail.start.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
    
            const endX = (event.detail.end.pos.x - this.host.props.width/2)/ this.host.props.scale - this.host.props.panX;
            const endY = (event.detail.end.pos.y - this.host.props.height/2)/ this.host.props.scale - this.host.props.panY;
    
            const bounds = {
                minX: Math.min(startX, endX),
                minY: Math.min(startY, endY),
                maxX: Math.max(startX, endX),
                maxY: Math.max(startY, endY)
            };

            // console.log('set marquee', bounds);

            // this.host.props.setZoomTo(bounds);

            this.host.directed.offsetX = 0;
            this.host.directed.offsetY = 0;
            
            this.host.tweenZoom(bounds,
                -(bounds.minX + bounds.maxX)/2, 
                -(bounds.minY + bounds.maxY)/2,
                20
            );

            this.host.setState({
                isShowingAll: false
            });

            // const pendingMultiselect = getIntersects(this.host.props.content.media, bounds);
            
            // this.host.props.addSelection(pendingMultiselect);
            
            // console.log('pendingMultiselect', pendingMultiselect,this.host.props.content.media);
            // this.host.props.setHover(pendingMultiselect);
            this.host.props.setHover();


            this.host.props.setCurrentTool('SELECT')//this.state.previousTool)

        }
    }

}
